import * as React from "react"
import { cn } from "@/lib/utils"

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <div className={cn("w-full group bg-secondary duration-200 transition-all", className)}>
      <div className="px-4">
        <input
          type={type}
          data-slot="input"
          className={cn(
            "w-full min-w-0 h-12 bg-transparent text-sm text-foreground",
            "placeholder:text-muted-foreground/50 outline-none",
            "file:inline-flex file:h-7 file:border-0 file:bg-transparent",
            "file:text-sm file:font-medium file:text-foreground",
            "disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
            "aria-invalid:text-destructive",
          )}
          {...props}
        />
      </div>
      {/*
        The rule, which is also how the field reports being invalid.

        `has-[[aria-invalid=true]]` reads the attribute FormControl already sets on the input, so
        an invalid field turns its own underline red. This replaces a red label and a line of red
        text under every field — stock shadcn error styling, which is the one thing on these
        pages that looked like a browser's own validation rather than like this app. The message
        itself goes to a toast; this is only "which field".
      */}
      <div className="relative h-px bg-border group-has-[[aria-invalid=true]]:bg-destructive">
        <div className="absolute inset-0 bg-foreground scale-y-0 group-focus-within:scale-y-[2] origin-bottom transition-transform duration-200 group-has-[[aria-invalid=true]]:bg-destructive" />
      </div>
    </div>
  )
}

export { Input }